import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { useEffect } from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Checkbox } from 'global/TradingModal/RealTradingModal/styled';
import { BondTransactionActionEnum } from 'global/Securities/types/api/bond';
import If from 'global/ErrorHandlers/If';
import PnLCurrency from 'features/trade/components/Portfolio/PnLCurrency';
import { Divider } from 'antd';
import { useBondsModalStore } from '../../stores/useBondsModalStore';
import { useBondTransaction } from '../../stores/useBondTransaction';
import { useBondPreviewStore } from '../../stores/useBondPreview';
import {
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
} from '../../styled';
import ModalTitle from '../ModalTitle';
import ModalProductDisplay from '../ModalProductDisplay';
import ContentBuy from './components/ContentBuy';
import ContentSell from './components/ContentSell';
import { BorderedWrapper, ConfirmButton } from './styled';
import useBondsAnalytics from '../../useBondsAnalytics';

export default function ModalBondConfirm() {
  const { FRBondActionTrackers, FRBondsNavigateTrackers } = useBondsAnalytics();
  const { closeModal, openTncModal, openOrderPlacedModal, sourcePage } =
    useBondsModalStore((s) => ({
      closeModal: s.closeModal,
      openTncModal: s.openTncModal,
      clearModal: s.clear,
      openOrderPlacedModal: s.openOrderPlacedModal,
      sourcePage: s.sourcePage,
    }));

  const {
    type,
    isTnCAccepted,
    setTnC,
    submitOrder,
    isSubmitSuccess,
    productId,
  } = useBondTransaction((s) => ({
    type: s.transactionType,
    isTnCAccepted: s.isTnCAccepted,
    setTnC: s.setTnC,
    submitOrder: s.submitOrder,
    isSubmitSuccess: s.isSuccess,
    productId: s.productId,
  }));

  const { clearPreview, sell } = useBondPreviewStore((s) => ({
    clearPreview: s.clear,
    sell: s.sell,
  }));

  const title =
    type === BondTransactionActionEnum.BUY
      ? `Buy ${productId}`
      : `Sell ${productId}`;

  const handleCheckboxChange = (event: CheckboxChangeEvent) => {
    if (event.target.checked) {
      FRBondActionTrackers.onTnCConfirmed();
    }

    setTnC(event.target.checked);
  };

  const handleSubmitOrder = () => {
    submitOrder();
    FRBondActionTrackers.onOrderConfirmed(
      type === BondTransactionActionEnum.BUY ? 'Buy' : 'Sell',
      productId,
      sourcePage,
    );
  };

  useEffect(() => {
    // If success, then redirect to the portfolio
    if (isSubmitSuccess) {
      clearPreview(); // clear buy/sell preview data
      // clearModal(); // clear modal state
      openOrderPlacedModal();
      FRBondsNavigateTrackers.onBondOrderSuccessViewed(
        type === BondTransactionActionEnum.BUY ? 'Buy' : 'Sell',
        productId,
        sourcePage,
      );
    }
  }, [isSubmitSuccess]);

  useEffect(() => {
    FRBondsNavigateTrackers.onBondPreviewOrderViewed(
      type === BondTransactionActionEnum.BUY ? 'Buy' : 'Sell',
      productId,
      sourcePage,
    );
  }, []);

  return (
    <>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle title={title} color="#333333" onClose={closeModal} />
        </ModalHeader>
        <ModalBody>
          <BorderedWrapper
            css={`
              padding-bottom: 0px;
            `}
          >
            <ModalProductDisplay />
            <If condition={type === BondTransactionActionEnum.BUY}>
              <ContentBuy />
            </If>
            <If condition={type === BondTransactionActionEnum.SELL}>
              <ContentSell />
            </If>
          </BorderedWrapper>
          <If condition={type === BondTransactionActionEnum.SELL}>
            <BorderedWrapper>
              <Flex align="center" justify="space-between">
                <div>
                  <Text family="bold" size="14px">
                    P&L (Nett)
                  </Text>
                </div>
                <PnLCurrency
                  amount={sell?.profit_loss_nett}
                  percentage={sell?.profit_loss_nett_percentage}
                  family="bold"
                />
              </Flex>
              <Divider
                css={`
                  margin: 12px 0px;
                `}
              />
              <Flex align="center" justify="space-between">
                <div>
                  <Text family="bold" size="14px">
                    Total Keuntungan
                  </Text>
                  <Text size="12px" color="#B5B5B5">
                    Selama Investasi
                  </Text>
                </div>
                <PnLCurrency
                  amount={sell?.total_realized_amount}
                  percentage={sell?.total_realized_amount_percentage}
                  family="bold"
                />
              </Flex>
            </BorderedWrapper>
          </If>
          {/* @ts-expect-error */}
          <Flex width="335px" mx="20px">
            <Checkbox checked={isTnCAccepted} onChange={handleCheckboxChange} />
            {/* @ts-expect-error */}
            <Text pl="8px" size="12px" as="span">
              Saya, Nasabah, telah membaca, menyetujui dan memahami{' '}
              <Text
                color={color.primary}
                onClick={openTncModal}
                aria-hidden="true"
                size="12px"
                as="span"
              >
                Syarat-syarat dan Ketentuan
              </Text>{' '}
              Efek Bersifat Utang dan Sukuk (EBUS) di Pasar Sekunder di atas
            </Text>
          </Flex>
        </ModalBody>
      </ModalContainer>
      <ModalFooter>
        <Flex
          justify="space-between"
          style={{ position: 'absolute', bottom: '-50px', width: '100%' }}
        >
          <Button
            onClick={closeModal}
            type="danger"
            radius="4px"
            block
            height="40px"
            style={{ width: '49%' }}
          >
            <Text align="inherit" color="white" family="bold" size="18px">
              Cancel
            </Text>
          </Button>

          <ConfirmButton
            onClick={handleSubmitOrder}
            radius="4px"
            block
            height="40px"
            style={{ width: '49%' }}
            disabled={!isTnCAccepted}
          >
            <Text
              align="inherit"
              color={isTnCAccepted ? color.primary : '#cbcbcb'}
              family="bold"
              size="18px"
            >
              Confirm
            </Text>
          </ConfirmButton>
        </Flex>
      </ModalFooter>
    </>
  );
}
